<div class="container">
    <h4>¿Esta seguro que desea cancelar la factura?</h4>
    <hr>
    <form [formGroup]="cancelReasonForm" (ngSubmit)="submitForm()">
        <div class="form-group">
            <label for="cancelReason">Motivo de cancelación:</label>
            <select formControlName="cancelReason" id="cancelReason" class="form-control" (change)="onCancelReasonChange()">
                <option *ngFor="let reason of cancelReasons" [value]="reason.id">{{ reason.attributes?.clave}} - {{reason.attributes.descripcion}}</option>
            </select>
        </div>
        <br>
        <mat-form-field class="inputFullWide" *ngIf="showUuidInput && showInput">
            <mat-label>CFDI que sustituye al cancelado</mat-label>
            <input matInput formControlName="relatedCFDI" id="uuid" placeholder="Ingrese el UUID" (change)="getRelatedInvoices($event)" (keyup.enter)="getRelatedInvoices($event)">
            <mat-icon>search</mat-icon>
        </mat-form-field>
        <div class="form-group" *ngIf="showUuidInput && !showInput">
            <mat-form-field class="example-full-width" appearance="fill">
                <mat-label>CFDI que sustituye al cancelado</mat-label>
                <input type="text" id="myInvoiceInput" matInput formControlName="relatedCFDI" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="optionSelected($event)">
                    <ng-container *ngIf="invoicesOptions">
                        <mat-option *ngFor="let option of invoicesOptions" [value]="attributes?.fac_factura_timbre?.data?.attributes?.uuid || option">
                            <div>
                                <label class="title">Folio:</label> {{option?.attributes?.folio}}
                            </div>
                            <div>
                                <label class="title">Receptor:</label> {{option?.attributes?.cli_cliente?.data?.attributes?.nombre}}
                            </div>
                            <div>
                                <label class="title">RFC:</label> {{option?.attributes?.cli_cliente?.data?.attributes?.rfc}}
                            </div>
                            <div>
                                <label class="title">Total:</label> {{option?.attributes?.total | currency:'MXN':'symbol':'1.2-2'}}
                            </div>
                        </mat-option>
                    </ng-container>
                </mat-autocomplete>
                <mat-icon svgIcon="mat_solid:close" (click)="eraseRelatedInvoices()"></mat-icon>
            </mat-form-field>
        </div>
        <div *ngIf="cancelReasonForm.get('relatedCFDI').errors?.required" class="text-danger">El CFDI relacionado es obligatorio.</div>
        <!-- <div *ngIf="cancelReasonForm.get('relatedCFDI').errors?.pattern" class="text-danger">El CFDI relacionado no es válido.</div> -->
        <hr>
        
        <div class="form-group d-flex justify-content-end">
            <button class="btn btn-default me-2" type="button" (click)="closeDialog()">Cancelar</button>
            <button class="btn btn-primary" type="button" (click)="acceptDialog()" [disabled]="!cancelReasonForm.valid">Aceptar</button>
        </div>
    
    </form>
</div>
